import { CssBaseline } from "@mui/material";
const Theme = () => {
  return <CssBaseline />;
};
export default Theme;
